// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"bef99c7d","488":"193a80e6","607":"53780a8d","655":"a7949e28"}[chunkId] + ".chunk.js";
};